<template>
<div class="col-12 text-left">
  <app-nav-bar></app-nav-bar>
  <div class="main-content">
    <h3 class="align-left">
      <small class="text-muted">Customer Complaint Quality</small>
    </h3>
    <div class="dropdown-divider"></div><br />
    <app-modal :elements="modalElements" v-on:confirm="del"></app-modal>
    <app-data-search v-on:searching="search"></app-data-search>
    <!-- <button type="button" class="btn btn-outline-primary" @click="add">Add  <i class="far fa-file"></i></button> -->
    <button type="button" class="btn btn-outline-info" @click="edit">Edit <i class="far fa-edit"></i></button>
    <!-- <button type="button" class="btn btn-outline-danger" data-toggle="modal" :data-target="`#${modalElements.modalId}`">Delete <i class="far fa-trash-alt"></i></button> -->
    <button type="button" class="btn btn-outline-success" @click="previewcparcc" style="margin-left: 20px;">Print CPAR-CC <i class="fas fa-print"></i></button>
    <button type="button" class="btn btn-outline-success" @click="previewccf" style="margin-left: 20px;">Print CCF <i class="fas fa-print"></i></button>
    <button type="button" class="btn btn-outline-success" @click="download" style="margin-left: 20px;">Download CCF Data <i class="fas fa-print"></i></button>
    <br /><br />
    <app-datatable :type="'view'" :elements="dtElements" :collections="ccq" v-on:selectedRow="selectRow"></app-datatable>
    <app-data-pagination v-on:pageChanged="changePage"></app-data-pagination>
  </div>
</div>
</template>

<script>
import api from '../../services/api'
import { customerComplaintQuality } from '../../models/customerComplaintQuality'
import AppDatatable from '../../components/AppDatatable.vue'
import AppModal from '../../components/AppModal.vue'
import AppDataPagination from '../../components/AppDataPagination.vue'
import AppDataSearch from '../../components/AppDataSearch.vue'
import AppNavBar from '../../components/AppNavbar.vue'
import download from 'js-file-download';

export default {
    components: {
      AppDatatable, AppModal, AppDataPagination, AppDataSearch, AppNavBar
    },
    data() {
      return {
        ccq: [customerComplaintQuality],
        dtElements: [
          {
            title: 'Complaint No',
            column: 'complaintNo',
            type: 'text'
          },
          {
            title: 'Reported Date',
            column: 'reportedDate',
            type: 'date'
          },
          {
            title: 'Product Name',
            column: 'productName',
            type: 'text'
          },
          {
            title: 'Customer Name',
            column: 'customerName',
            type: 'text'
          },
          {
            title: 'Status',
            column: 'status',
            type: 'text'
          },
          {
            title: 'Description',
            column: 'description',
            type: 'text',
          },
          {
            title: 'Total Days Open',
            column: 'totalDaysOpen',
            type: 'text',
          },
          {
            title: 'Overdue (Days)',
            column: 'overDue',
            type: 'text',
          },
        ],
        modalElements: {
          modalId: 'customer-complaint-quality',
          title: 'Confirm',
          content: 'Are you sure to delete this data?',
          type: 'text-confirm'
        },
        selectedId: '',
        searchKey: '',
        pagination: {
          pageSize: 10,
          currentPage: 1
        }
      }
  },
  async created() {
    this.init()
  },
  methods: {
    async init() {
      const ccqApi = api('customer-complaint-final-approval/partial')
      const query = {
        params: {
          searchKey: this.searchKey,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize
        }
      }
      this.ccq = await ccqApi.getWithQuery(query) 
    },
    add() {
      // this.$router.push({ name: 'customerComplaintAreaOwnerDetail' })
    },
    edit() {
      if(this.selectedId !== '') {
        this.$router.push({
          name: 'customerComplaintQualityDetail',
          query: {
            id: this.selectedId
          }
        })
      }
    },
    previewcparcc() {
      if(this.selectedId !== '') {
        // this.$router.push({
        //   name: 'cpar-cc',
        //   query: {
        //     id: this.selectedId
        //   }
        // })
        let newTab = this.$router.resolve({name: 'cpar-cc', query: {id: this.selectedId}});
        window.open(newTab.href, '_blank');
      }
    },
    previewccf() {
      if(this.selectedId !== '') {
        // this.$router.push({
        //   name: 'ccf',
        //   query: {
        //     id: this.selectedId
        //   }
        // })
        let newTab = this.$router.resolve({name: 'ccf', query: {id: this.selectedId}});
        window.open(newTab.href, '_blank');
      }
    },
    async download() {
      const rptApi = api('print/cc-partial')
      const query = { 
        params: {
        }
      }
      const excelFile = await rptApi.getFileWithQuery(query)
      download(excelFile, 'CCF-Data.xlsx')
    },
    async del() {
      // if(this.selectedId !== '') {
      //   const ccqApi = api('customer-complaint-corrective')
      //   await ccqApi.delete(this.selectedId)
      //   this.init()
      // }
    },
    selectRow(id) {
      this.selectedId = id
    },
    changePage(payload) {
      this.pagination = payload
      this.init()
    },
    search(searchKey) {
      this.searchKey = searchKey
      this.init()
    }
  }
}
</script>